PJQ.views.projects.Attachments = PJQ.views.files.FileNavigator.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Attachments'),
		subTemplates: {
			file: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Attachment'),
			fileMenu: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Attachment-Menu')
		},
		sortBy: 'name',
		sortDirection: 'asc',
		isHideDrawings: false,
		enableDrawings: false,
		canAdd: false,
		canShare: false,
		isAdmin: false,
		isReadOnly: false,
		hideHeader: false,
		foldersOnly: false
	},
	events: {
		'click .btn-upload-raw-files': 'uploadRawFiles',
		'click .btn-attach-documents': 'attachRootAttachments',
		'click .btn-add-shared-folder': 'addSharedFolderClicked',
		'click .btn-add-private-folder': 'addPrivateFolderClicked',
		'click .btn-add-to-drawings': 'addToDrawingsClicked',
		'click .btn-select-contents': 'selectFolderContentsClicked',
		'click .btn-add-selected-to-drawings': 'addSelectedToDrawings',
		'change .input-select-all': 'allChecked',
		'click .btn-download-all': 'downloadAll'
	},
	beforeFirstRender: function () {
		let prefs;
		if (this.options.project != null) {
			prefs = this.options.project.preferences;

			this.options.enableDrawings = !this.options.isHideDrawings && !this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DRAWINGS);
			this.options.canAdd = (this.options.project.get('masterUserId') === PJQ.app.session.get('masterUserId')
				&& this.options.project.hasPermission('attachments.canAdd'));
			this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.get('masterUserId')
				&& this.options.project.hasPermission('attachments.isAdmin');
			this.options.canShare = this.options.project.get('masterUserId') === PJQ.app.session.get('masterUserId')
				&& this.options.project.hasPermission('attachments.canShare')
				&& !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_SHARE_PEI);
			this.options.foldersOnly = this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.RSVP_FOLDER_CHECKBOXES_ONLY) &&
				this.options.project.get('masterUserId') !== PJQ.app.session.get('masterUserId');

			this.options.canAddDrawings = PJQ.app.session.project != null
				&& PJQ.app.session.project.hasPermission('drawings.isAdmin')
				&& (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId'));
		}
		else {
			prefs = PJQ.app.session.preferences;
		}

		if (prefs != null) {
			if(prefs.hasPref(PJQ.constants.preferenceTypes.EXPAND_PROJECT_ATTACHMENTS)){
				this.options.expandAllFolders = true;
			}

			// this has to read from session, it is a portal preference
			let sfOverride = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_SHARED_FOLDER_NAME_OVERRIDE);
			if(_.size(sfOverride) > 0){
				this.options.sharedFolderNameOverride = sfOverride;
			}
		}

		if (this.options.isReadOnly) {
			this.options.canAdd = false;
			this.options.canShare = false;
			this.options.isAdmin = false;
			this.options.canAddDrawings = false;
		}

		this.fetchAttachments({
			isPrivate: this.options.project == null || !this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_PROJECT_PRIVATE_ATTACHMENTS)
		});
	},
	getMenuActions: function () {
		let self = this;
		return [
			{
				name: 'Attach Folders',
				onClick: function () {
					self.attachRootAttachments();
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.canAdd && attachment.get('entryId') === -1;
				}
			},
			{
				name: 'New Folder',
				onClick: function (attachment) {
					self.addFolder(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.canAdd && attachment.get('isFolder');
				}
			},
			{
				name: 'Upload',
				onClick: function (attachment) {
					self.uploadToFolder(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.canAdd && attachment.get('entryId') > 0 && attachment.get('isFolder');
				}
			},
			{
				name: 'Download',
				onClick: function (attachment) {
					self.downloadAttachments(attachment);
				},
				isShown: _.bind(function (attachment) {
					if(this.options.foldersOnly && !attachment.get('isFolder')){
						return false;
					}

					return PJQ.app.session.project.get('isOnline') && (!attachment.get('isFolder') || _.size(attachment.getFolderAttachments()) > 0);
				}, this)
			},
			{
				name: 'View',
				onClick: function (attachment) {
					new PJQ.views.files.FileViewer({
						model: attachment
					});
				},
				isShown: function (attachment) {
					return attachment.get('name').toLowerCase().endsWith('.pdf');
				}
			},
			{
				name: 'Order',
				onClick: function (attachment) {
					self.order(attachment);
				},
				isShown: _.bind(function (attachment) {
					if(this.options.foldersOnly && !attachment.get('isFolder')){
						return false;
					}

					return PJQ.app.session.project.get('isOnline') && (!attachment.get('isFolder') || _.size(attachment.getFolderAttachments()) > 0);
				}, this)
			},
			{
				name: 'Share',
				onClick: function (attachment) {
					self.shareAttachments(attachment);
				},
				isShown: function () {
					return self.options.canShare;
				}
			},
			{
				name: 'Export File List',
				onClick: function (attachment) {
					self.exportFileList(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && attachment.get('entryId') > 0 && attachment.get('isFolder');
				}
			},
			{
				name: 'Add to Drawings',
				onClick: function (attachment) {
					self.addToDrawings(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin
						&& !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DRAWINGS)
						&& attachment.get('entryId') > 0 && attachment.getDepth() > 0
						&& self.options.canAddDrawings;
				}
			},
			{
				name: 'Select Contents',
				onClick: _.bind(function (attachment) {
					this.selectFolderContents(attachment);
				}, this),
				isShown: function (attachment) {
					return attachment.get('isFolder');
				}
			},
			{
				name: 'Cut',
				onClick: function (attachment) {
					self.cutAttachments(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0
						&& attachment.getDepth() > 0;
				}
			},
			{
				name: 'Copy',
				onClick: function (attachment) {
					self.copyAttachments(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0
						&& attachment.getDepth() > 0;
				}
			},
			{
				name: 'Paste',
				onClick: function (attachment) {
					self.paste(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0
						&& attachment.get('isFolder') && self.clipboard != null;
				}
			},
			{
				name: 'Rename',
				onClick: function (attachment) {
					self.renameAttachment(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0
						&& attachment.getDepth() > 0;
				}
			},
			{
				name: 'Properties',
				onClick: function (attachment) {
					self.attachmentProperties(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0;
				}
			},
			{
				name: 'Delete',
				isDanger: true,
				onClick: function (attachment) {
					self.deleteAttachments(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0
						&& attachment.get('folderId') > 0;
				}
			},
			{
				name: 'Detach',
				isDanger: true,
				onClick: function (attachment) {
					self.deleteAttachments(attachment);
				},
				isShown: function (attachment) {
					return !attachment.get('isDrawing') && self.options.isAdmin && attachment.get('entryId') > 0 &&
						attachment.get('folderId') === -1;
				}
			},
		];
	},
	selectFolderContentsClicked: function (e) {
		let $attachment = $(e.currentTarget).closest('.attachment'),
			attachment = this.collection.get($attachment.data('cid'));
		this.selectFolderContents(attachment);
	},
	selectFolderContents: function (folder) {
		this.addSelectedAttachmentIds(_.map(folder.getFolderAttachments(true), function (att) {
			return att.cid;
		}));
		this.getAttachmentElement(folder).siblings('.attachment-files-outer').find('.input-select-attachment').prop('checked', true);
	},
	uploadRawFiles: function () {
		new PJQ.views.files.RawFileUploaderModal({
			project: this.options.project
		});
	},
	allChecked: function (e) {
		let isChecked = $(e.currentTarget).prop('checked');
		this.$('.input-select-attachment').prop('checked', isChecked);
		if (isChecked) {
			let attachmentIds = _.map(this.collection.models, function (attachment) {
				return attachment.cid;
			});
			this.addSelectedAttachmentIds(attachmentIds);
		}
		else {
			this.selectedAttachmentIds = [];
		}
	},
	addSharedFolderClicked: function () {
		this.addFolder(this.collection.getSharedFolder());
	},
	addPrivateFolderClicked: function () {
		this.addFolder(this.collection.getPrivateFolder());
	},
	attachRootAttachments: function () {
		new PJQ.views.files.FileSelector({
			foldersOnly: true,
			disabledAttachmentIds: _.map(this.collection.models, function (attachment) {
				return attachment.get('entryId');
			}),
			onSave: _.bind(function (files) {
				this.options.project.attachFiles(files, _.bind(function () {
					this.collection.fetch();
					PJQ.notifications.notify.successNotify({
						message: "Attached files successfully"
					});
				}, this));
			}, this)
		});
	},
	shareAttachments: function (attachments) {
		attachments = this.replaceVersionFolders(attachments);

		let shareDrawings = new PJQ.collections.drawings.Drawings(),
			versionIds = [];

		shareDrawings.options.allDrawings = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DRAWING_SHARE_PREVENT_EXPIRATION);

		if (PJQ.helpers.objectHelpers.refinedType(attachments) === 'array') {
			_.each(_.filter(attachments, function (attachment) {
				return !attachment.get('isFolder') && attachment.get('isDrawing');
			}), function (attachment) {
				if (versionIds.indexOf(attachment.get('versionId')) === -1) {
					versionIds.push(attachment.get('versionId'));
				}
				shareDrawings.add(new PJQ.models.drawings.Drawing({
					guid: attachment.get('guid')
				}));
			});
		}
		else if (attachments.get('isDrawing')) {
			versionIds.push(attachments.get('versionId'));
			shareDrawings.add(new PJQ.models.drawings.Drawing({
				guid: attachments.get('guid')
			}));
		}

		if (_.size(shareDrawings.models) > 0) {
			let fileGuids = _.map(_.filter(attachments, function (attachment) {
					return !attachment.get('isDrawing');
				}), function (attachment) {
					return attachment.get('guid');
				}),
				sharingModal = new PJQ.views.sharing.SharingModal({
					collection: shareDrawings,
					project: this.options.project,
					onSave: _.bind(function (data) {
						shareDrawings.share(versionIds, fileGuids, data, this.options.project, _.bind(function (share) {
							PJQ.notifications.notify.successNotify({
								message: 'File share email sent'
							});
						}, this));
					}, this)
				});
			shareDrawings.share(versionIds, fileGuids, null, this.options.project, function (share) {
				let callback = _.bind(sharingModal.urlChanged, sharingModal);
				callback(share.url);
			});
		}
		else {
			let shareAtt = [],
				fnCheck = function (att) {
					if (att.get('entryId') === -1) {
						shareAtt.push(...att.getFolderAttachments());
					}
					else {
						shareAtt.push(att);
					}
				};
			if (PJQ.helpers.objectHelpers.refinedType(attachments) === 'array') {
				_.each(attachments, function (att) {
					fnCheck(att);
				});
			}
			else {
				fnCheck(attachments);
			}
			let files = new PJQ.collections.files.Files(shareAtt),
				sharingModal = new PJQ.views.sharing.SharingModal({
					project: this.options.project,
					onSave: _.bind(function (data) {
						files.share(data, this.options.project, _.bind(function (share) {
							PJQ.notifications.notify.successNotify({
								message: 'File share email sent'
							});
						}, this));
					}, this)
				});
			files.share(null, this.options.project, function (share) {
				let callback = _.bind(sharingModal.urlChanged, sharingModal);
				callback(share.url);
			});
		}
	},
	downloadAll: function () {
		this.downloadAttachments(this.collection.models);
	},
	addToDrawingsClicked: function (e) {
		let $attachment = $(e.currentTarget).closest('.attachment'),
			attachment = this.collection.get($attachment.data('cid'));
		this.addToDrawings(attachment);
	},
	addSelectedToDrawings: function () {
		this.addToDrawings(this.collection.get(this.selectedAttachmentIds));
	},
	addToDrawings: function (files) {
		if (PJQ.helpers.objectHelpers.refinedType(files) === 'object') {
			files = [files];
		}
		PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/drawings', {
			trigger: true
		});
		let versions = new PJQ.collections.drawings.Versions(null, {
			project: this.options.project
		});
		versions.fetch({
			success: _.bind(function () {
				new PJQ.views.drawings.DrawingBatchModal({
					versions: versions,
					project: this.options.project,
					model: new PJQ.models.drawings.DrawingBatch({
						files: files,
						projectId: this.options.project.id
					})
				});
			}, this)
		});
	}
});

PJQ.views.projects.AttachmentsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'modal-project-attachments'),
		subTemplates: {},
		maxWidth: 1400,
		onSave: _.noop
	},
	events: {
		'click .btn-save': 'onSave'
	},
	afterRender: function () {
		if (PJQ.app.session.project) {
			this.attachmentsView = new PJQ.views.projects.Attachments({
				el: this.$('.modal-body'),
				expandSharedFolders: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.EXPAND_PROJECT_ROOT_SHARED_FOLDERS),
				project: PJQ.app.session.project,
				isReadOnly: PJQ.app.session.project.get('status') === 'ARCHIVE'
			})
		}
	},
	onSave: function () {
		this.options.onSave(this.attachmentsView.collection.get(this.attachmentsView.selectedAttachmentIds));
		this.removeModal();
	}
});

